import {DISABLE_ALL_FEATURES, SET_EXPERIMENTAL_FEATURE_IS_ENABLED} from './constants';

export const initialExperimentalFeatures = {};

export function experimentalFeatures(state = initialExperimentalFeatures, action) {
    switch (action.type) {
        case SET_EXPERIMENTAL_FEATURE_IS_ENABLED:
            return Object.assign({}, state, {
                [action.featureKey]: action.isEnabled
            });
        case DISABLE_ALL_FEATURES:
            return Object.assign({}, initialExperimentalFeatures);
        default:
            return state;
    }
}

